import React from 'react';
import { View, Text, StyleSheet } from 'react-native';
import { MainColors } from '../constants/Colors';
import FontSizes from '../constants/FontSizes';
import MainButton from '../components/Buttons/MainButton';

const TwoLineMessage = (props) => {
    return (
        <View style={{ flex: 1, justifyContent: 'center', paddingHorizontal: 30 }}>
            <Text style={styles.firstLine}>{props.firstLine}</Text>
            <Text style={styles.secondLine}>{props.secondLine}</Text>
            {props.createMode ? (
                <MainButton
                    style={{ marginTop: 30 }}
                    onPress={props.onButtonPress}
                    text={props.buttonText}
                    accessibilityLabel={props.buttonAccessibilityLabel}
                    accessibilityHint={props.buttonAccessibilityHint}
                />
            ) : (null)}
        </View>
    )
}

const styles = StyleSheet.create({
    firstLine: {
        color: MainColors.darkGray,
        fontSize: FontSizes.medium,
        paddingBottom: 8,
        textAlign: 'center',
        fontWeight: '600',
        lineHeight: 24,
    },
    secondLine: {
        color: MainColors.darkGray,
        textAlign: 'center',
        fontSize: FontSizes.medium,
        fontWeight: '400',
        lineHeight: 24
    }
});

export default TwoLineMessage;